module.exports = __webpack_public_path__ + "static/img/medicalcareservice.421776a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lp/medicalcareservice.png
// module id = Jjfc
// module chunks = 0